const navbarReducer = (
    state = {
        title: "HYK",
        showBackArrow: true,
    },
    action
) => {
    switch (action.type) {
        case 'SET_TOP_NAVBAR_OBJECT':
            state = {
                ...state,
                ...action.payload
            }
            break;
    }
    return state;
};

export default navbarReducer;

